export default __webpack_public_path__ + "static/media/avatar-default-icon.7addbb99.svg";